export default "__VITE_ASSET__DdBj3AMY__"